// Legal Information Reducer

const legalInformationReducerDefaultState = {
    id: '',
    idBeneficiaire: '',
    testament: false,
    notary: false,
    firstName: '',
    name: '',
    idAddress: '',
    address: '',
    zipCode: '',
    city: '',
    codeCountry: '',
    tel: '',
    dateCreation:'',
    dateModification: ''
};

export default (state = legalInformationReducerDefaultState, action) => {
    switch (action.type) {
        case 'GET_LEGAL_INFORMATION':
            return {
                ...state,
                id: action.data.id,
                idBeneficiaire: action.data.idBeneficiaire,
                name: action.data.name,
                date: action.data.date,
                firstName: action.data.firstName,
                idAddress: action.data.idAddress,
                address: action.data.address,
                zipCode: action.data.zipCode,
                city: action.data.city,
                codeCountry: action.data.codeCountry,
                tel: action.data.tel,
                testament: action.data.testament,
                notary: action.data.notary,
                dateCreation: action.data.dateCreation,
                dateModification: action.data.dateModification,
            };
        case 'SET_LEGAL_INFORMATION':
            return {
                ...state,
                id: action.data.id,
                idBeneficiaire: action.data.idBeneficiaire,
                name: action.data.name,
                date: action.data.date,
                firstName: action.data.firstName,
                idAddress: action.data.idAddress,
                address: action.data.address,
                zipCode: action.data.zipCode,
                city: action.data.city,
                codeCountry: action.data.codeCountry,
                tel: action.data.tel,
                testament: !!+action.data.testament,
                notary: !!+action.data.notary,
                dateCreation: action.data.dateCreation,
                dateModification: action.data.dateModification,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/legalInformation.js